import AnionTestingPart from './AnionTestingPart';

export default function Part5Sulfide() {
  return (
    <AnionTestingPart
      partNumber={5}
      anionSymbol="S2-"
      anionName="Sulfide"
      anionFormula="0.1 M Na2S"
      anionColor="#CFD8DC"
      infoContent={{
        title: 'Metal Sulfides',
        content: 'Metal sulfides show dramatic color variations! CuS, NiS, CoS, and FeS are black. ZnS is white. MnS is flesh-colored. These colors are due to d-orbital electron transitions.'
      }}
    />
  );
}
